<template>
    <div class="ml-container">

        <LottieLoader></LottieLoader>

    </div>
</template>

<script>

import Auth from '@/modules/auth'
import UserFlow from '@/modules/userFlow'

import Storage from '@/helpers/storage'

import LottieLoader from '@/components/lottie/LottieLoader'

export default {

    name: 'microsoft-loading',

    components: {
        LottieLoader
    },

    created() {
        UserFlow.setPage(this, 'microsoft_loading')
    },

    mounted() {

        const aToken = this.$route.query.token

        if (aToken) {

            Auth.microsoftAuth(this, aToken)
                .then(() => {

                    this.$router.push({path: '/fetch'})
                })
                .catch(error => {

                    this.microsoftErrorFlow(error.message)

                })
        } else {

            this.$router.push({path: '/fetch'})

        }

    },

    methods: {

        microsoftErrorFlow(errorCatched) {

            let route = Storage.getItem('token') ? 'add-inbox' : 'landing'

            const error = errorCatched || this.$route.query.error || 'default'

            this.$router.push({name: route, params: {error: error}})
        }

    }
}
</script>

<style lang="scss" scoped>

.ml-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}


</style>
